import { DropdownLayout } from '@wix/design-system';
import { EditSparklesSmall, ImageSparklesSmall } from '@wix/wix-ui-icons-common';
import React, { useContext } from 'react';

import { EditorContext, ModalServiceContext, RicosContext } from './../../ricos-context';
import type { ModalService } from './../../ricos-modals';
import type { TiptapEditor } from './../../ricos-types';

import { AI_FLOW_ITEM_CONTENT, AI_FLOW_ITEM_IMAGE, AI_FLOW_SELECTION_POPOVER } from '../data-hooks';
import type { Prompt } from '../types';
import styles from './ai-flow-selection-modal-scss';

type AiFlowSelectionModalProps = {
  toggleAiContentModal: (
    editor: TiptapEditor,
    modalsService: ModalService,
    initialPrompt?: Prompt
  ) => void;
  toggleAiImageModal: (editor: TiptapEditor, modalsService: ModalService) => void;
};

export const AiFlowSelectionModal: React.FC<AiFlowSelectionModalProps> = ({
  toggleAiContentModal,
  toggleAiImageModal,
}) => {
  const { t } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);
  const { adapter } = useContext(EditorContext);

  const options = React.useMemo(() => {
    const commonOptions = {
      as: 'button',
      ellipsis: false,
      size: 'small',
      skin: 'standard',
      title: false,
      value: 'action',
      shouldFocusWithoutScroll: true,
    };
    return [
      {
        ...commonOptions,
        dataHook: AI_FLOW_ITEM_CONTENT,
        id: 'ai-content',
        onClick: () => toggleAiContentModal(adapter.tiptapEditor, modalService),
        optionTitle: t('AIPlugin_Flow_ContentAssistant'),
        prefixIcon: <EditSparklesSmall />,
      },
      {
        ...commonOptions,
        dataHook: AI_FLOW_ITEM_IMAGE,
        id: 'ai-image',
        onClick: () => toggleAiImageModal(adapter.tiptapEditor, modalService),
        optionTitle: t('AIPlugin_Flow_ImageGenerator'),
        prefixIcon: <ImageSparklesSmall />,
      },
    ];
  }, []);

  return (
    <DropdownLayout
      dataHook={AI_FLOW_SELECTION_POPOVER}
      className={styles.dropdown}
      maxHeightPixels={250}
      minWidthPixels={206}
      visible
      options={options}
    />
  );
};
